import { isFalsy, isString } from '../../Helpers/helpers';

/**
 * Title Cases a String -- Capitalizes First Letter of All Words
 * @function toTitleCase
 * @param {string} str
 * @return {string}
 * @example toTitleCase('TEST STRING OK') => 'Test String Ok'
 * @example totTitleCase('TeST string OK') => 'Test String Ok'
 */
const toTitleCase = (str, preserveExistingCapitalization) => {
  if (isFalsy(str) || !isString(str)) return '';
  return str.replace(
    /\w\S*/g,
    (txt) => {
      const rest = txt.slice(1);
      return txt.charAt(0).toUpperCase() + (preserveExistingCapitalization ? rest : rest.toLowerCase());
    }
  );
};

export default toTitleCase;
